import { getState } from 'src/store';
import { labelToId } from '../common';
import { callContractTransaction, callContractView } from './common';

export const nameExpires = async (label: string): Promise<string> => {
  const id = labelToId(label);
  const timestamp = await callContractView('Registrar', 'nameExpires', [id]);
  const timestampInMilliseconds = Number(timestamp) * 1000;
  const date = new Date(timestampInMilliseconds);
  const formattedDate = date.toISOString().split('T')[0];
  return formattedDate;
};

export const available = async (label: string): Promise<boolean> => {
  const id = labelToId(label);
  const available = await callContractView('Registrar', 'available', [id]);
  return available;
};

export const register = async (
  label: string,
  numberOfYears: number,
  tokenAddress: string,
  registrationCost: number,
) => {
  const wallet = getState().wallet;
  if (tokenAddress === '0x0000000000000000000000000000000000000000') {
    await callContractTransaction(
      'Registrar',
      'register',
      [label, wallet?.address, tokenAddress, numberOfYears],
      '',
      registrationCost.toString(),
    );
  } else {
    await callContractTransaction('Registrar', 'register', [
      label,
      wallet?.address,
      tokenAddress,
      numberOfYears,
    ]);
  }
};

export const renew = async (
  label: string,
  renewalPeriod: number,
  tokenAddress: string,
  renewalCost: number,
) => {
  if (tokenAddress === '0x0000000000000000000000000000000000000000') {
    await callContractTransaction(
      'Registrar',
      'renew',
      [label, tokenAddress, renewalPeriod],
      '',
      renewalCost.toString(),
    );
  } else {
    await callContractTransaction('Registrar', 'renew', [
      label,
      tokenAddress,
      renewalPeriod,
    ]);
  }
};
